import { calculateCampaignStatus } from "Utils/Campaign/campaignStatusUtils";
import { formatDate } from "Utils/DateUtils";
import { Resources, type TFunction } from "Translations/Resources";

type CampaignWithDates = {
  startDate?: Date | string | null;
  endDate?: Date | string | null;
  status?: string;
};

export const getStatusMessage = (campaign: CampaignWithDates, t: TFunction) => {
  const campaignStatus = calculateCampaignStatus(campaign);
  if (!campaignStatus) {
    return null;
  }

  const resources = Resources.Campaigns.Campaign.Page;
  const statusMessageLookup = {
    "not-started": {
      severity: "info" as const,
      title: t(resources.StatusNotStarted),
      message: campaign.startDate
        ? t(resources.StatusNotStartedWithDate, {
            date: formatDate(campaign.startDate),
          })
        : t(resources.StatusNotStartedWithoutDate),
    },
    finished: {
      severity: "warning" as const,
      title: t(resources.StatusFinished),
      message: campaign.endDate
        ? t(resources.StatusFinishedWithDate, {
            date: formatDate(campaign.endDate),
          })
        : t(resources.StatusFinishedWithoutDate),
    },
    unlimited: null,
    active: null,
    draft: null,
    archived: null,
  } as const;

  return statusMessageLookup[campaignStatus] ?? null;
};
